import { render, staticRenderFns } from "./ClientContractMaterial.vue?vue&type=template&id=7580c0cf&"
import script from "./ClientContractMaterial.vue?vue&type=script&lang=js&"
export * from "./ClientContractMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports